import Vue from 'vue';
import store from '../../store';
import { Role, ROUTES, ADMIN_ROLE } from '../constants';
import { getAuthentication } from '../utils';

const getHomepage = (role) => {
  if (role === Role.CATERING) {
    return ROUTES.CATERING;
  }
  return ROUTES.MENU;
};

const initializeAdditionalResources = async (store, isCatering = false) => {
  let promises = [];
  promises.push(store.dispatch('diets/initializeDiets'));
  promises.push(store.dispatch('offices/initializeOffices'));
  promises.push(store.dispatch('companies/initializeCompanies'));
  // We don't need allergies if we are from catering service
  if (!isCatering) {
    promises.push(store.dispatch('allergies/initializeAllergies'));
  }
  return Promise.all(promises);
};

export const setupUserInStore = async (to, from, next) => {
  const auth = await getAuthentication(Vue);
  const { isAuthenticated } = auth;
  let user = store.getters['user/getUser'];

  // Get user and its data
  if (isAuthenticated && !user.isInitialized) {
    await store.dispatch('user/initializeUser');

    // TODO: Add catering role on this function call
    // https://wizeline.atlassian.net/browse/FM-656
    initializeAdditionalResources(store);
    const weekNumber = store.state.weeklyMenu.weekNumber;

    if (user.role === ADMIN_ROLE) {
      const office = user.office;
      await store.dispatch('orders/initializeWeekOrders', { office, weekNumber });
    }
  }

  next();
};

export const requiresAuthGuard = async (to, from, next) => {
  const { isAuthenticated } = await getAuthentication(Vue);
  const { requiresAuth } = to.meta;
  if (requiresAuth && !isAuthenticated) {
    next(ROUTES.HOME);
    return;
  }

  next();
};

export const authenticatedGuard = async (to, from, next) => {
  const user = store.getters['user/getUser'];
  const userRole = user.role;
  const { isAuthenticated } = await getAuthentication(Vue);
  const { requiresAuth } = to.meta;
  if (isAuthenticated && !requiresAuth) {
    const homePage = getHomepage(userRole);
    next(homePage);
    return;
  }

  next();
};

export const rolesGuard = async (to, from, next) => {
  const { isAuthenticated } = await getAuthentication(Vue);
  const { requiresAuth, authorizedRoles } = to.meta;

  if (!requiresAuth) {
    next();
    return;
  }

  if (!isAuthenticated) {
    next(ROUTES.HOME);
    return;
  }

  const user = store.getters['user/getUser'];
  const userRole = user.role;
  const userNotAllowed = !authorizedRoles.includes(userRole);
  if (userNotAllowed) {
    const homePage = getHomepage(userRole);
    next(homePage);
  }

  next();
};



// WEBPACK FOOTER //
// ./src/router/guards.js